import { createAction } from '@reduxjs/toolkit';
import slice from './slice';

export default { ...slice?.actions };